import React from 'react'
import './cohorts-landing.styles.scss';
import { useSelector } from 'react-redux';
import CohortList from '@/components/ADMIN/cohorts/cohort-list.component';
import { Route, Routes } from 'react-router-dom';
import CohortView from '@/components/SHARED/cohort-view/cohort-view.component';

const CohortsLanding = () => {

    const myCohorts = useSelector(state => state.contentData.myCohorts);


    return (
        <div className='cohorts-landing'>
            <Routes>
                <Route path='' element={
                    <div className='g-card cohorts-card'>
                        <div className='section-title'>My Cohorts</div>
                        <hr className='no-top-margin' />
                        {
                            (myCohorts) &&
                            <CohortList
                                cohorts={myCohorts} />
                        }   

                    </div>
                }></Route>
                <Route path='view/:cohortPath/*' element={
                    <div className='g-card cohorts-card'>
                        <CohortView />
                    </div>
                }></Route>
            </Routes>
        </div>
    )
}

export default CohortsLanding;